import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';
export const getDepartment = () => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() + `department/company-department`
  );
};
export const AddDepartment = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `department/company-department/create`,
    obj,
    { headers }
  );
};

export const EditDepartment = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `department/company-department/update`,
    obj,
    { headers }
  );
};
export const DeleteDepartment = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `department/company-department/delete`,
    obj,
    { headers }
  );
};
